import React from 'react'

import { getVerifyResetPasswordCode } from '../../../api/auth'
import useQuery from '../../../hooks/useQuery'
import {
  error,
  initial,
  isInitial,
  loading,
  success,
} from '../../../utils/remoteData'

function useVerifyResetPasswordCodeRequest() {
  const [verifyCodeRequest, setVerifyCodeRequest] = React.useState(initial())
  const query = useQuery()
  const code = query.get('code')

  if (!code && isInitial(verifyCodeRequest)) {
    setVerifyCodeRequest(error('This link has expired'))
  }

  React.useEffect(() => {
    async function verifyCode() {
      if (code && isInitial(verifyCodeRequest)) {
        try {
          setVerifyCodeRequest(loading())
          const data = await getVerifyResetPasswordCode({ code })
          setVerifyCodeRequest(success(data))
        } catch (err) {
          setVerifyCodeRequest(error(err.message))
        }
      }
    }
    verifyCode()
  }, [code, verifyCodeRequest])

  return {
    verifyCodeRequest,
    code,
  }
}

export default useVerifyResetPasswordCodeRequest
